import { render, staticRenderFns } from "./CashbackBalanceLocksTable.vue?vue&type=template&id=98f29184&scoped=true"
import script from "./CashbackBalanceLocksTable.vue?vue&type=script&lang=js"
export * from "./CashbackBalanceLocksTable.vue?vue&type=script&lang=js"
import style0 from "./CashbackBalanceLocksTable.vue?vue&type=style&index=0&id=98f29184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f29184",
  null
  
)

export default component.exports